module.exports = new __parcel__URL__("level_5_tab_inactive.38302979.png").toString();